import { AND, OR } from '@/lib/filter/scope-tree';
import { guid } from 'shared/lib/uuid';
import { propertyType, userScopeType } from 'shared/constants.json';

const goalPropertiesTypeUser = (goalProperties) => goalProperties.filter((p) => p.type === propertyType.user);

export const personalGoalsFilter = ({ goalProperties, user, account, quickFilterKey = guid() }) => {
  const props = goalPropertiesTypeUser(goalProperties);
  if (props.length === 0) {
    return null;
  }
  return {
    account,
    key: guid(),
    op: AND,
    children: [
      {
        op: OR,
        key: quickFilterKey,
        isGroup: true,
        children: props.map((p) => ({
          key: guid(),
          op: AND,
          children: [
            {
              op: AND,
              scope: {
                isEmpty: false,
                property: p,
                users: [user],
                type: userScopeType.property,
              },
            },
          ],
        })),
      },
    ],
  };
};

// quickFilters for a personal goals view: a single user property is a normal
// single-property quick filter, but with >1 the personal filter is an OR across
// properties ("goals where I'm involved in any role") and must be an advanced
// filter — as a quick filter it renders as one misleading chip and hides the
// individual properties from being filtered on their own.
export const personalGoalsQuickFilters = (goalProperties, quickFilterKey) => (
  goalPropertiesTypeUser(goalProperties).length === 1 ? [quickFilterKey] : []
);
